import React, { useState } from "react"
import {
  Button,
  Container,
  Card,
  CardBody,
  Row,
  Badge,
  Col,
  Modal,
} from "reactstrap"
import { Link } from "react-router-dom"
import Select2 from "react-select2-wrapper"
import { Rate } from "antd"
import { useFirestore } from "react-redux-firebase"

class CustomerOrderCards extends React.Component {
  state = {
    sortBy: "name",
    orders: [],
  }

  componentDidMount() {}

  render() {
    return (
      <>
        <div className="header pt-5 pb-7">
          <Container className="chift-container">
            <div className="header-body">
              <Row className="mb-2 sortby">
                <Col sm={4}>
                  <h1>Your Orders</h1>
                </Col>
                <Col sm={3}>
                  <span className="sortbyTxt">sort by </span>
                  <Select2
                    value={this.state.sortBy}
                    data-minimum-results-for-search="Infinity"
                    className="form-control faver-sort"
                    defaultValue={"name"}
                    onChange={(e) => this._handleSort(e, "sortBy")}
                    data={[
                      { id: "name", text: "Name" },
                      { id: "price", text: "Price" },
                      { id: "jobs", text: "Jobs" },
                    ]}
                  />
                  <i className="fa fa-angle-down" aria-hidden="true"></i>
                </Col>
              </Row>
              <Row className="align-items-center">
                {this.props.orders && <OrderCards orders={this.props.orders} />}
              </Row>
            </div>
          </Container>
        </div>
      </>
    )
  }
}

function OrderCards({ orders }) {
  const [visible, setVisible] = useState(false)
  const [orderDetail, setOrderDetail] = useState({})
  const [detailsVisible, setDetailsVisible] = useState(false)
  const [ratingOrderId, setRatingOrderId] = useState(null)
  const [rating, setRating] = useState(null)
  const dismiss = () => {
    setVisible(false)
    setRating(null)
    setRatingOrderId(null)
  }
  const dismissDetails = () => {
    setDetailsVisible(false)
    setOrderDetail({})
  }
  const firestore = useFirestore()
  const submit = async () => {
    try {
      await firestore.collection("orders").doc(ratingOrderId).update({
        rating,
      })
    } catch (error) {
      console.log(`{error}`, { error })
    } finally {
      dismiss()
    }
  }
  const ratingCompleted = (rating) => {
    setRating(rating)
  }
  if (orders) {
    return (
      <>
        <Modal
          size="sm"
          className="modal-dialog-centered"
          isOpen={visible}
          toggle={dismiss}
        >
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-default">
              Rate your experience
            </h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={dismiss}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Rate onChange={ratingCompleted} value={rating} />
          </div>
          <div className="modal-footer">
            <Button
              className="ml-auto"
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={dismiss}
            >
              DISMISS
            </Button>
            <Button color="success" type="button" onClick={submit}>
              SUBMIT
            </Button>
          </div>
        </Modal>
        <Modal
          size="lg"
          className="modal-dialog-centered"
          isOpen={detailsVisible}
          toggle={dismissDetails}
        >
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-default">
              Order Details
            </h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={dismissDetails}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <h3> {orderDetail?.merchantName}</h3>
            <b>Vehicle Type:</b> {orderDetail?.vehicleType?.title}
            <br />
            <b>Package:</b>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <p style={{ flex: 1 }}>{orderDetail?.package?.title} </p>
              <p>${orderDetail?.package?.cost} </p>
            </div>
            {!!orderDetail?.addon?.length && <b>Addons:</b>}
            {orderDetail?.addon?.map((e) => (
              <div
                style={{ display: "flex", flexDirection: "row" }}
                key={JSON.stringify(e)}
              >
                <p style={{ flex: 1 }}>{e.title || ""} </p>
                <p>${e.cost || ""} </p>
              </div>
            ))}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <b style={{ flex: 1 }}>Total:</b>
              <p>${orderDetail?.totalCost} </p>
            </div>
            <b>Date:</b>
            <p>{orderDetail?.orderDate?.toDate()?.toDateString()}</p>
            <b>Time:</b>
            <p>{orderDetail?.orderTime}</p>
            <b>Address:</b>
            <p>
              {[
                orderDetail?.addressLine1,
                orderDetail?.addressLine2,
                orderDetail?.city,
                orderDetail?.zipCode,
              ]
                .filter((p) => p)
                .join(", ")}
            </p>
            <b>Order ID:</b>
            <p>{orderDetail?.id}</p>
          </div>
        </Modal>
        {orders.map((order, idx) => {
          const pathname = `/order/${order.orderId || ""}`
          let orderStatus = "Placed"

          if (order.merchantCancelled) {
            orderStatus = "Cancelled"
          } else if (order.merchantConfirmed) {
            orderStatus = "Confirmed"
            if (order.merchantStopped) {
              orderStatus = "Completed"
            }
          }
          console.log(order)
          return (
            <Col lg="12" key={idx}>
              <Card className="orderListcards">
                <CardBody>
                  <Row className="align-items-center">
                    <Col className="col-auto" xs="2">
                      <span
                        className="avatar avatar-xl rounded-rectangle"
                        onClick={(e) => e.preventDefault()}
                      >
                        <img
                          alt={order.name}
                          src={
                            order.merchantLogo ||
                            require("assets/img/theme/light-grey-bg.png")
                          }
                        />
                      </span>
                    </Col>
                    <Col className="col-auto" xs="10">
                      <Row>
                        <Col
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setOrderDetail(order)
                            setDetailsVisible(true)
                          }}
                        >
                          <h2 className="mb-0 ml-2">{order.merchantName}</h2>
                          {order.rating && (
                            <div className="text-muted text-sm mb-2 ml-2">
                              <Rate disabled defaultValue={order.rating} />
                            </div>
                          )}
                          <span
                            className="text-muted text-sm mb-0 ml-2"
                            style={{ fontWeight: "bold" }}
                          >
                            {" "}
                            <i className="fas fa-calendar-alt"></i>&nbsp;
                            {order.orderDate.toDate().toDateString()} |{" "}
                            <i className="fas fa-clock"></i>&nbsp;
                            {order.orderTime} | Order ID:{" "}
                            {order.id.slice(22, -1)}
                          </span>
                        </Col>
                        <Col md="3">
                          <div>
                            {orderStatus === "Completed" && !order.rating && (
                              <Button
                                onClick={() => {
                                  setVisible(true)
                                  setRatingOrderId(order.orderId)
                                }}
                              >
                                Rate
                              </Button>
                            )}
                            <Badge
                              color="primary"
                              className="faver-verified-badge"
                              pill
                            >
                              Verified{" "}
                              <i
                                className="fa fa-check-circle text-primary"
                                aria-hidden="true"
                              ></i>
                            </Badge>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="col">
                          {order.vehicleType &&
                            order.vehicleType.length > 0 &&
                            order.vehicleType.slice(0, 3).map((vType, idx) => {
                              return (
                                <Link
                                  key={idx}
                                  to={{
                                    pathname,
                                    state: {
                                      order,
                                      vehicleType: vType,
                                    },
                                  }}
                                >
                                  <Button
                                    className="mx-1 mb-2"
                                    color="primary"
                                    size="sm"
                                    type="button"
                                  >
                                    {vType.title}
                                  </Button>
                                </Link>
                              )
                            })}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          )
        })}
      </>
    )
  }
  return (
    <Row>
      <Col className="text-center">
        <p>No Orders to show.</p>
      </Col>
    </Row>
  )
}

export default CustomerOrderCards
